import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageCross: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="page-cross, close, x, document, list, file"><path d="M13.25 21.25H4.75V2.75H19.25V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.8713 16.6287L18.75 18.75M16.6287 20.8713L18.75 18.75M16.6287 16.6287L18.75 18.75M20.8713 20.8713L18.75 18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPageCross;
